import { TAttachmentDetails } from '@monorepo/types';
import moment from 'moment';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableTextCellColors, TTableTreeModel } from '../../table.type';

const TEXT_COLOR_MAP: Record<TAttachmentDetails['status'], { text: string; color: TTableTextCellColors }> = {
  AVAILABLE: { text: 'AVAILABLE', color: 'DEFAULT' },
  ACTIVE: { text: 'ACTIVE', color: 'GREEN' },
  IN_REPAIR: { text: 'IN REPAIR', color: 'RED' },
  REPAIR_REJECTED: { text: 'REPAIR REJECTED', color: 'RED' },
};

export const ATTACHMENT_LIST_TABLE_MODEL = {
  createModel: (
    attachments: TAttachmentDetails[],
    selectedAttachments: TAttachmentDetails[],
    hasEditAccess: boolean,
  ) => {
    return ModifiersZTableModel.createTableModel(
      attachments,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'table_model.ATTACHMENT_TYPE', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.ATTACHMENT_SERIAL_ID', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.MACHINETYPE', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.CATEGORY', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.SUB-CATEGORY', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.BRAND', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.STATUS', widthInPx: 100 },
          { type: 'TEXT_CELL', text: 'table_model.LAST_UPDATED', widthInPx: 100 },
          ...(hasEditAccess
            ? [
                { type: 'TEXT_CELL' as const, text: '', widthInPx: 50 },
                { type: 'TEXT_CELL' as const, text: '', widthInPx: 50 },
              ]
            : []),
        ],
        select: { isMulti: true, position: 'START', size: 'DEFAULT' },
      },
      (item) => ({
        type: 'ROW',
        rowItem: item,
        rowSelectionInfo: {
          isSelected: selectedAttachments.some((attachment) => attachment.serialNumber === item.serialNumber),
          isDisabled: false,
        },
        cells: [
          { type: 'TEXT_CELL', text: item.attachmentType, widthInPx: 100 },
          { type: 'TEXT_CELL', text: item.serialNumber, widthInPx: 100 },
          { type: 'TEXT_CELL', text: item.machineType, widthInPx: 100 },
          { type: 'TEXT_CELL', text: item.machineCategory, widthInPx: 100 },
          { type: 'TEXT_CELL', text: item.machineSubCategory ?? '- -', widthInPx: 100 },
          { type: 'TEXT_CELL', text: item.machineBrand, widthInPx: 100 },
          {
            type: 'TEXT_CELL',
            text: TEXT_COLOR_MAP[item.status].text,
            textColor: TEXT_COLOR_MAP[item.status].color,
            widthInPx: 100,
          },
          { type: 'TEXT_CELL', text: moment(item.lastUpdatedOn).format('hh:mm A, DD/MM/YYYY'), widthInPx: 100 },
          ...(hasEditAccess
            ? [
                { type: 'ACTION_CELL' as const, actionType: 'EDIT' as const, asIcon: true, widthInPx: 50 },
                { type: 'ACTION_CELL' as const, actionType: 'DELETE' as const, asIcon: true, widthInPx: 50 },
              ]
            : []),
        ],
      }),
    );
  },

  deselectAllRows: (tableModel: TTableTreeModel<TAttachmentDetails>): TTableTreeModel<TAttachmentDetails> => {
    return ModifiersZTableModel.deselectAllRows(tableModel);
  },
};
